// extracted by mini-css-extract-plugin
module.exports = {"title":"ItemActionPanel_title__Yqqfd","icon":"ItemActionPanel_icon__3RLhO","wrapper":"ItemActionPanel_wrapper__2G8Pu","bc":"ItemActionPanel_bc__C4_8m"};